// import 'babel-polyfill'
import Vue from 'vue'
import App from '@/views/app'
import router from '@/service/router'
import store from '@/service/store'
import Http from '@/service/http'
import i18n from '@/service/locale'//多语言
import { isPC } from '@/utils'
import {
  Toast,
  Button,
  Dialog,
  Icon,
  NoticeBar
} from 'vant'
import dataRanger from '@/service/data-rangers'

// 注册全局组件
Toast.setDefaultOptions('loading', { forbidClick: true })
Vue.use(Toast)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(NoticeBar)

Vue.use(Http)
Vue.use(dataRanger)

if (process.env.NODE_ENV === 'production') {
  Vue.config.productionTip = false
}
// 禁止双指缩放
document.addEventListener('gesturestart', function(event) {
  event.preventDefault();
});
document.addEventListener('gesturechange', function(event) {
  event.preventDefault();
});

// 移动端注入fastclick
if (!isPC()) {
  import('raw-loader!mds-libs-vendors/fastclick')
    .then(rawModule => eval.call(null, rawModule.default))
    .then(() => window.FastClick.attach(document.body))
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
